import router from "./router";
import i18n from "./i18n";

export const servicesModuleRouter = router;
export const servicesModuleI18n = i18n;
